export default {
    accessToken: state => (
        state.accessToken || sessionStorage.getItem('accessToken')
    ),

    error: state => state.error,

    user: state => state.user
};
